import * as sonbp from "sonbp";
import * as ifbase from "../base";

/**
* 銀塩・印刷フロント描画用リスナー
*/
export class poscaFrontDrawer extends sonbp.listener.baseListener {

	protected _ifdto: ifbase.ifDto;


	// -----------------------------------------------
	// Constructors（コンストラクタ）
	// -----------------------------------------------

	/**
	 * コンストラクタ
	 */
	public constructor(ifdto: ifbase.ifDto) {
		super();

		this._ifdto = ifdto;

		this._drawer = true;
		this._isDrawWhileMovingCanvas = true;
		this._eventListener = true;
	}

	// -----------------------------------------------
	// Properties（内部変数）
	// -----------------------------------------------

	/** 背景画像 */
	private _bgImgUrl: string = "/posca/img/pc/desktop/default/spk_02_Thumb_back01_parts.png";

	/** 画像キャッシュ */
	private _bgImgCache: HTMLImageElement = null;

	// -----------------------
	// イベント受付機能 関数
	// -----------------------

	// -----------------------
	// 描画機能 関数
	// -----------------------

	/**
	 * frontCanvasへの描画
	 * @override
	 */
	//public drawFrontCanvas(co: sonbp.draw.canvasOperator): void {
	//}

	/**
	 * frontPageCanvasへの描画
	 * @override
	 */
	public drawFrontPageCanvas(co: sonbp.draw.canvasOperator): void {

		if (ifbase.util.chkIsPhotoManiInSP(this._ifdto)) {
			//this.drawFrontPage4PhotoManiInSP(co);
			return;
		}

		let isPC = this._ifdto.client == ifbase.constants.CLIENT_PC ? true : false;

		// 印刷/銀塩切り替えの背景設定
		this._bgImgUrl = "/posca/img/pc/desktop/default/spk_02_Thumb_back01_parts.png"
		
		let v = this._ifdto.bpView;

		//Ｐの描画矩形
		if (this._ifdto.areaType == "1") {
			// 印刷

			let that = this;
			let drawFunc = function () {

				//PDFのページサイズ
				let dBox = v._om._doc.pages[0].size.media_box;
				//Ｃのサイズ
				let c = v._dm.getFixedViewRect();
				//Ｐのサイズ
				let p = new sonbp.type.rectPoint(dBox[0] * v._dm.scaleRate, dBox[1] * v._dm.scaleRate, dBox[2] * v._dm.scaleRate, dBox[3] * v._dm.scaleRate);

				let bpad1 = isPC ? 1 : 10;
				let bpad2 = isPC ? 2 : 20;
				let basePt = new sonbp.type.point((c.width - p.width) / 2, (c.height - p.height) / 2);
				let pRect = new sonbp.type.rectPoint(
					basePt.x - bpad1 + that._ifdto.pageOffset.x,
					basePt.y - bpad1 - that._ifdto.pageOffset.y,
					basePt.x + p.width + bpad2 + that._ifdto.pageOffset.x,
					basePt.y + p.height + bpad2 - that._ifdto.pageOffset.y
				);

				co.ctx.save();
				co.clearContext();
				//console.log("drawFrontPageCanvas 1");

				const pattern = co.ctx.createPattern(that._bgImgCache, 'repeat');
				co.ctx.fillStyle = pattern;
				co.ctx.fillRect(pRect.x1, pRect.y1, pRect.width, pRect.height);

				// 縦横判定
				let isV = false;
				if (p.height > p.width) isV = true;

				let bleedLen = 0;
				let x, y, w, h = 0;
				if (isV) {

					//立ち落としサイズ(左右2mm)
					bleedLen = (p.width * 2) / 104;

					// 左上原点
					x = ((c.width - p.width) / 2) + bleedLen;
					y = (c.height - p.height) / 2;
					w = (p.width) - (bleedLen * 2);
					h = (p.height);

					//拡縮誤差
					if (!isPC) {
						y += 1;
						h -= 2;
					}
				} else {

					//立ち落としサイズ(上下2mm)
					bleedLen = (p.height * 2) / 104;

					x = (c.width - p.width) / 2;
					y = ((c.height - p.height) / 2) + bleedLen;
					w = p.width;
					h = p.height - (bleedLen * 2);

					//拡縮誤差
					if (!isPC) {
						x += 1;
						w -= 2;
					}
				}

				if (that._ifdto.pageOffset) {
					x += that._ifdto.pageOffset.x;
					y -= that._ifdto.pageOffset.y;
				}

				if (isPC) {
					// シャドウはPC版のみ
					co.ctx.shadowColor = 'black';      // 影の色
					co.ctx.shadowBlur = 8;            // ぼかし
					co.ctx.fillRect(x, y, w, h);
				} else {
					co.ctx.fillStyle = 'black';
					co.ctx.fillRect(x - 1, y - 1, w + 2, h + 2);
				}

				// pdfを露出させる
				co.ctx.clearRect(x, y, w, h);

				co.ctx.restore();
			};

			if (this._bgImgCache == null) {

				const img = new Image();
				img.onload = (() => {

					that._bgImgCache = img;

					if (that._ifdto.areaType == "1") {
						drawFunc();
					}
				});
				img.src = that._bgImgUrl;
			} else {

				drawFunc();
			}

		} else {
			//銀塩

			//PDFのページサイズ
			let dBox = v._om._doc.pages[0].size.media_box;
			//Ｃのサイズ
			let c = v._dm.getFixedViewRect();
			//Ｐのサイズ
			let p = new sonbp.type.rectPoint(dBox[0] * v._dm.scaleRate, dBox[1] * v._dm.scaleRate, dBox[2] * v._dm.scaleRate, dBox[3] * v._dm.scaleRate);

			let x = (c.width - p.width) / 2;
			let y = (c.height - p.height) / 2;
			const w = p.width;
			const h = p.height

			if (this._ifdto.pageOffset) {
				x += this._ifdto.pageOffset.x;
				y -= this._ifdto.pageOffset.y;
			}

			co.ctx.save();
			co.clearContext();
			//console.log("drawFrontPageCanvas 2");

			// シャドウはPC版のみ
			if (isPC) {
				co.ctx.shadowColor = 'black';      // 影の色
				co.ctx.shadowBlur = 8;            // ぼかし
				co.ctx.fillRect(x, y, w, h);
			} else {
				// SPは黒フチ
				co.ctx.fillStyle = 'black';
				co.ctx.fillRect(x - 1, y - 1, w + 2, h + 2);
			}

			// pdfを露出させる
			co.ctx.clearRect(x, y, w, h);

			co.ctx.restore();
		}

	}

	/**
	 * SPモードでの写真操作中
	 */
	public drawFrontPage4PhotoManiInSP(co: sonbp.draw.canvasOperator): void {

		let clipImage = this._ifdto.activeSelector.getItemObjects()[0] as sonbp.object.groupItem;

		if (!clipImage || !clipImage.gstate.hasSoftMask) {
			//マスク画像無し
			return;
		}

		let maskData = this._v._cm.getImg(clipImage.gstate.soft_mask.src, clipImage._apply_pageIdx, clipImage._apply_layerIdx, 0, false, false, true);

		if (!(maskData.status == 2 || maskData.img.complete)) {
			//マスク画像読込未完了
			return;
		}

		//マスク画像を描画
		co.ctx.save();
		{
			this._v._dm.pageTransform(0, co.ctx);

			//背景黒部分
			let pad = ifbase.constants.SP_PHOTO_MANI_PADDING / 2;
			let clipRect = clipImage.rect;
			let clipRectBig = new sonbp.type.rectPoint(clipRect.x1 - pad, clipRect.y1 - pad, clipRect.x2 + pad, clipRect.y2 + pad);

			co.ctx.fillStyle = 'black';
			co.ctx.fillRect(clipRectBig.x1, clipRectBig.y1, clipRectBig.width, clipRectBig.height);
			co.ctx.clearRect(clipRect.x1 + 1, clipRect.y1 + 1, clipRect.width - 2, clipRect.height - 2);

			co.ctx.beginPath();
			co.ctx.moveTo(clipRect.x1, clipRect.y1);
			co.ctx.lineTo(clipRect.x2, clipRect.y1);
			co.ctx.lineTo(clipRect.x2, clipRect.y2);
			co.ctx.lineTo(clipRect.x1, clipRect.y2);
			co.ctx.closePath();
			co.ctx.clip();

			//マスク部分
			let maskDataImg = maskData.img;

			let mb = clipImage.gstate.soft_mask_bounds;
			co.ctx.transform(1, 0, 0, 1, mb[0], mb[1]);

			let mm = clipImage.gstate.soft_mask_matrix;
			co.ctx.transform(mm[0], mm[1], mm[2], mm[3], mm[4], mm[5]);

			co.ctx.transform(1, 0, 0, -1, 0, mb[3] - mb[1]);
			co.ctx.drawImage(maskDataImg, 0, 0, maskDataImg.width, maskDataImg.height, 0, 0, mb[2] - mb[0], mb[3] - mb[1]);
		}
		co.ctx.restore();

	}
}